import React, { useContext, useEffect, useState } from "react";
import { DailyPanditBookingAPI } from "../../ApiServices/DailyPanditAPI/DailyPanditApi";
import {
  Link,
  UNSAFE_shouldHydrateRouteLoader,
  useNavigate,
} from "react-router-dom";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import Batuk from "../../assets/images/new/Batuk2.png";
import { LoaderContext } from "../../AuthContext/AuthContext";
import Breadcrumbs from "../../Components/Breadcrumb";

const DailyBooking = () => {
  const user_id = localStorage.getItem("userID");
  const [searchKeyWord, setSearchKeyWord] = useState("");
  const [dailyPanditPujaListData, setDailyPanditPujaListData] = useState([]);
  const [searchBtnClick, setSearchClicked] = useState(false);
  const { setLoader, loader } = useContext(LoaderContext);
  const navigate = useNavigate();

  useEffect(() => {
    GetMyBookPanditPujaListData();
  }, []);

  useEffect(() => {
    if (searchBtnClick) {
      GetMyBookPanditPujaListData();
      setSearchClicked(false);
    }
  }, [searchBtnClick]);

  const GetMyBookPanditPujaListData = async () => {
    setLoader(true);
    try {
      const response = await DailyPanditBookingAPI(user_id, {
        START: 1,
        END: 10,
        WORD: searchKeyWord,
        LATITUDE: "20.008581",
        LONGITUDE: "73.76413099999999",
      });

      if (
        response.ResponseCode === "0" &&
        response.ResponseMessage === "list"
      ) {
        setDailyPanditPujaListData(response.DATA);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const viewDetail = (puja) => {
    console.log("Navigating to details with puja:", puja);
    const newSlug = puja?.DailyPujaSlug;
    navigate(`/services/daily-booking/puja-details/${newSlug}`, {
      state: { puja: puja },
    });
    // navigate("/services/daily-booking/puja-details", {
    //   state: { puja: puja },
    // });
  };

  return (
    <div
      className="container mt-4 mb-3"
      style={{ display: "flex", flexDirection: "column" }}
    >
      {/* <Breadcrumbs
        items={[
          { label: "Home", url: "/" },
          { label: "Products", url: "/products" },
          { label: "Smartphones", url: "/products/smartphones" },
        ]}
      /> */}
      <Breadcrumbs />
      {/* Search Bar */}
      <div className="row mb-3">
        <div className="col-md-6 mx-auto">
          <div
            className="search-box"
            style={{
              position: "relative",
              flex: "1",
              maxWidth: "100%",
              marginRight: "10px",
            }}
          >
            <input
              type="text"
              className="custom-search-input"
              placeholder="Search"
              value={searchKeyWord}
              onChange={(e) => setSearchKeyWord(e.target.value)}
              style={{
                padding: "8px 35px 8px 10px",
                width: "100%",
              }}
            />
            <span
              onClick={() => {
                setSearchClicked(true);
              }}
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                color: "#a52444",
              }}
            >
              <i className="fas fa-search"></i>
            </span>
          </div>
        </div>
      </div>

      {/* Puja List Heading */}
      {/* <h4 className="text-center mb-4" style={{ fontFamily: "Poppins" }}>
        Daily Puja Services
      </h4> */}

      {/* Puja Cards */}
      <div className="row" style={{ justifyContent: "left" }}>
        {dailyPanditPujaListData?.length !== 0 ? (
          dailyPanditPujaListData.map((puja, index) => (
            <div className="col-lg-3 col-md-6 col-sm-6 product-item-one ">
              <div
                className=" card card-shadow-sty shadow-sm bg-white rounded p-2 w-100 d-flex h-100  "
                style={{ cursor: "pointer" }}
                onClick={() => viewDetail(puja)}
              >
                <div className="product-image text-center position-relative ">
                  <img
                    src={puja.DP_IMAGE || placeholderImg}
                    className="card-img-top"
                    alt={puja.DP_NAME}
                    onError={(e) => {
                      e.target.onerror = null; // Prevent infinite loop
                      e.target.src = placeholderImg; // Set fallback image
                    }}
                    style={{ height: "200px", objectFit: "contain" }}
                  />
                  {/* <span className="discount-badge position-absolute top-0 start-0 bg-danger text-white p-1 small">
              {product.PUJA_DISC ? `${product.PUJA_DISC}% OFF` : ""}
            </span> */}
                </div>
                <div
                  className="product-details text-center d-flex align-item-center justify-content-center flex-column flex-grow-1 p-2"
                  style={{ margin: "0" }}
                >
                  <h6
                    style={{
                      fontSize: "18px",
                      color: "#8f3246",
                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    {puja.DP_NAME}
                  </h6>
                  <div className="prod-details d-flex align-items-center flex-column">
                    <span style={{ fontSize: "16px", whiteSpace: "nowrap" }}>
                      ₹{" "}
                      {Math.round(
                        Number(puja.DP_PRICE) -
                          (Number(puja.DP_PRICE) * Number(puja.DP_DISC)) / 100
                      )}{" "}
                      / Day
                    </span>

                    <Link
                      to="/puja-details"
                      // className="btn btn-sm"
                      style={{
                        // backgroundColor: "#a52444",
                        color: "#a52444",
                        fontWeight: "500",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "5px",
                      }}
                    >
                      View Details <i className="icon-right-arrow"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : loader === false ? (
          <div className="d-flex flex-column align-items-center justify-content-center vh-90 text-center mt-4">
            <img
              src={Batuk}
              alt="Empty Cart"
              className="img-fluid mb-3"
              style={{ maxWidth: "200px" }}
            />
            <h5 className="fw-bold" style={{ textAlign: "center" }}>
              No Pujas available
            </h5>
            <p className="text-muted">Please explore our other Pujas.</p>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default DailyBooking;
